import {Component, inject, OnInit} from '@angular/core';
import {PatientManagementService} from '../../patient-management.service';
import {PatientDto} from '../../dtos/patient.dto';
import {MemoryService} from '../../../../core/services/memory.service';
import {Router, RouterOutlet} from '@angular/router';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatRippleModule} from '@angular/material/core';
import {RedirectService} from '../../../../core/services/redirect.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';

@Component({
  selector: 'app-profile',
  imports: [RouterOutlet, MatDividerModule, MatIconModule, TranslocoPipe, MatRippleModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  mode: 'mobile' | 'desktop' = 'desktop';

  patientManagementService: PatientManagementService = inject(PatientManagementService);
  memoryService = inject(MemoryService);
  router = inject(Router);
  redirectService = inject(RedirectService);
  errorService = inject(ErrorService);
  translocoService = inject(TranslocoService);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 705px)',     // mobile
      '(min-width: 704px)'      // desktop
    ]).subscribe(result => {
      if (result.breakpoints['(max-width: 705px)']) {
        this.mode = 'mobile';
      } else if (result.breakpoints['(min-width: 704px)']) {
        this.mode = 'desktop';
      }
    });
  }

  get routeNumber(): number {
    switch (this.router.url) {
      case "/profile/appointments":
      case "/profile/appointment-details":
        return 1;
      default:
        return 0;
    }
  }

  ngOnInit() {
    const patientId = this.memoryService.patientId;
    if (!patientId) {
      const url = this.router.url;
      const state = history.state;
      this.redirectService.set({url: url, state: state});

      this.router.navigate(["/login"]);
      return;
    }

    this.patientManagementService.getPatient(patientId).subscribe({
      next: (patientDto: PatientDto) => {
        this.patientManagementService.patientDto = patientDto;
      },
      error: (error: HttpErrorResponse) => {
        this.translocoService.selectTranslate('error.title.patient').subscribe(title => {
          this.errorService.handleError(error, this.translocoService.translate(title));
        })
      }
    })
  }

  profile() {
    this.router.navigate(['/profile']);
  }

  appointments() {
    this.router.navigate(['/profile/appointments']);
  }
}
